<div class="wrapper">
  <div class="heading text-type-2 mb-[40px]">
    {{ data?.source?.name || 'Edit equipment' }}
  </div>
  <form>
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableSearch]="subContractorOptions.length >= 10"
      [error]="errorMessages['sub_contractor']"
      [options]="subContractorOptions"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="sub_contractor"
      label="Contractor"
    />
    <div class="flex flex-row gap-[20px] w-full mb-[20px]">
      <app-number-input
        [parentFormGroup]="form"
        class="w-1/2"
        controlName="quantity"
        label="Quantity"
      />
      <app-number-input
        [parentFormGroup]="form"
        class="w-1/2"
        controlName="hours"
        [isDecimalAllowed]="true"
        label="Hours"
      />
    </div>
    <app-text-area
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="comment"
      label="Comment"
    />
  </form>
</div>
